module.exports = __webpack_public_path__ + "img/balance-stones.944812a.jpg";